/* global axios */
import ApiClient from './ApiClient';

class AiReplySuggestionsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/ai_reply_suggestions`);
  }

  create(conversationId) {
    return axios.post(`${this.url}/${conversationId}/ai_reply_suggestions`);
  }
}

export default new AiReplySuggestionsAPI();
